export const TREE = 'recommendationsModule'
export const TABLE_BRANCH = 'table'

// Routes
export const RECOMMENDATIONS_ROUTE = '/recommendations'
